import React from 'react';
import bookingLogo from '../../assets/images/Booking-logo.png';
import defaultUserIcon from '../../assets/images/default-user.png';
import styles from './Header.module.css';
import { serviceConstants } from '../../utils/constant';

const Header = () => {
  const tokenData = localStorage.getItem(serviceConstants.OKTA_TOKEN_KEY);
  let userName = '';

  if (tokenData) {
    const parsedData = JSON.parse(tokenData);
    userName = parsedData.idToken?.claims?.sAMAccountName || '';
  }
  return (
    <div className={styles.navbarContainer} data-testid={'headerDivTestId'}>
      <div className={styles.logoContainer}>
        <img className={styles.logo} src={bookingLogo} alt={'Booking logo'} />
        <p className={styles.headerText}>Crisis Panic Button</p>
      </div>
      <div className={styles.defaultUserContainer}>
        <img className={styles.defaultUserIcon} src={defaultUserIcon} alt={'User avatar image'} />
        <p className={styles.userNameInfo}>{userName}</p>
      </div>
    </div>
  );
};

export default Header;
